

export const informEndOfWeetGeneration = () => {
  // @ts-ignore
  window.__endAutoGeneration = true;
  console.log("Add __endAutoGeneration")
};

/**
 * Publishes a human-readable progress message for the headless generation
 * worker (speach-generator) to pick up. The worker polls window.__generationProgress
 * on every frame (like __endAutoGeneration) and forwards the last message to
 * Redis so speach-core can show it on the "generation in progress" page.
 */
export const informWeetGenerationProgress = (message: string) => {
  // @ts-ignore
  window.__generationProgress = message;
};
